// 화장장 견적 퍼널 리드 제출 시 #홈 질문으로 보낼 사람용 스토리 빌더.
// v2: 헤더·전화번호·🚨·임박도(status)·ops멘션은 BE/구조화 필드가 처리. 여기선 스토리만.

export interface CrematoriumLeadMessageParams {
  /** Q1 답변 (시점) */
  q1Answer: string;
  /** Q2 답변 (상황) */
  q2Answer: string;
  /** Q3 답변 (궁금한 점) */
  q3Answer: string;
}

export function buildCrematoriumLeadMessage({
  q1Answer,
  q2Answer,
  q3Answer,
}: CrematoriumLeadMessageParams): string {
  const body =
    "화장장 관련 정보를 요청하신 고객님입니다.\n화장 예약은 장례지도사가 빠르게 잘하고, 예약 어려울 경우 첫일 안치실에 모시는 방안 설명 필요합니다.\n궁금한 점 내용에 맞게 상담을 진행하고, 추가적인 세일즈 부탁드립니다.";

  return `질문 내용 : *화장장 문의*\n\n상황: *${q1Answer}* / *${q2Answer}*\n궁금한 점: *${q3Answer}*\n-----\n${body}`;
}
